module.exports = __webpack_public_path__ + "files/c37404106a88ba52ca3a262f52d615a0.png";